/* eslint-disable no-console */
/* eslint-disable import/prefer-default-export */
import _ from 'lodash'
import { colors, createMuiTheme, responsiveFontSizes } from '@material-ui/core'
import typography from './typography'
import { softShadows, strongShadows } from './shadows'
import { THEMES } from '../constants'

const baseConfig = {
  direction: 'ltr',
  typography,
  overrides: {
    MuiLinearProgress: {
      root: {
        borderRadius: 3,
        overflow: 'hidden'
      }
    },
    MuiListItemIcon: {
      root: {
        minWidth: 32
      }
    },

    MuiChip: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.075)'
      }
    }
  }
}

const themeConfigs = [
  {
    name: THEMES.LIGHT,
    overrides: {
      MuiInputBase: {
        input: {
          '&::placeholder': {
            opacity: 1,
            color: '#524fad'
          }
        }
      },
      MuiCard: {
        root: {
          boxShadow:
            '0 0 1px 0 rgb(0 0 0 / 31%), 0 5px 13px -4px rgb(0 0 0 / 25%)'
        }
      }
    },
    palette: {
      type: 'light',
      action: {
        active: '#524fad'
      },
      background: {
        default: colors.common.white,
        dark: '#F3F6F8',
        paper: colors.common.white
      },
      primary: {
        main: '#41348a'
      },
      secondary: {
        main: '#4f4fcd'
      },
      text: {
        primary: colors.blueGrey[900],
        secondary: colors.blueGrey[600]
      },
      icons: {
        primary: '#41348a'
      }
    },
    shadows: softShadows
  },
  {
    name: THEMES.ONE_DARK,
    overrides: {
      MuiCard: {
        root: {
          boxShadow:
            '0 0 1px 0 rgb(0 0 0 / 31%), 0 1px 13px -1px rgb(0 0 0 / 35%)'
        }
      }
    },
    palette: {
      type: 'dark',
      action: {
        active: 'rgba(255, 255, 255, 0.54)',
        hover: 'rgba(255, 255, 255, 0.04)',
        selected: 'rgba(255, 255, 255, 0.08)',
        disabled: 'rgba(255, 255, 255, 0.26)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        focus: 'rgba(255, 255, 255, 0.12)'
      },
      background: {
        default: '#282C34',
        dark: '#1C2025',
        paper: '#282C34'
      },
      primary: {
        main: '#8a85ff'
      },
      secondary: {
        main: '#8a85ff'
      },
      text: {
        primary: '#e6e5e8',
        secondary: '#adb0bb'
      },
      icons: {
        primary: '#C9C9C9'
      }
    },
    shadows: strongShadows
  }
]

export function createTheme(settings = {}) {
  let themeConfig = themeConfigs.find(theme => theme.name === settings.theme)

  if (!themeConfig) {
    console.warn(new Error(`The theme ${settings.theme} is not valid`))
    ;[themeConfig] = themeConfigs
  }

  let theme = createMuiTheme(
    _.merge({}, baseConfig, themeConfig, { direction: settings.direction })
  )

  if (settings.responsiveFontSizes) {
    theme = responsiveFontSizes(theme)
  }

  return theme
}
